module.exports = function displayFirstName(user) {
    if (! user) return ''
    // return first name, or user_name as a fallback
    const first_name = user.first_name || ''
    const user_name = user.user_name || ''
    const name = first_name.trim() || user_name.trim()
    return name
}
